/* ============================================================
   Tasty Flavours — Collection Grid
   AJAX "In winkelwagen" met aantal-stepper.
   Geen dependencies. Werkt op elk Shopify thema (cart/add.js).
   ============================================================ */
(function () {
  'use strict';

  /* Gedeelde toast (rechtsboven). Eén instantie voor alle secties + de PDP. */
  function tfToast(msg) {
    if (window.__tfToastFn) { window.__tfToastFn(msg); return; }
    var wrap = document.createElement('div');
    wrap.className = 'tf-toast-wrap';
    document.body.appendChild(wrap);
    window.__tfToastFn = function (m) {
      var t = document.createElement('div');
      t.className = 'tf-toast';
      t.setAttribute('role', 'status');
      t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg><span></span>';
      t.querySelector('span').textContent = m || 'Toegevoegd aan winkelwagen';
      wrap.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('is-in'); });
      setTimeout(function () {
        t.classList.remove('is-in'); t.classList.add('is-out');
        setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 380);
      }, 2600);
    };
    window.__tfToastFn(msg);
  }

  var TF_DRAWER_SELECTORS = ['cart-drawer', '#CartDrawer', '#cart-drawer', '.cart-drawer', '.drawer--cart', 'cart-notification', '#cart-notification'];

  function tfFindDrawer() {
    for (var i = 0; i < TF_DRAWER_SELECTORS.length; i++) {
      var el = document.querySelector(TF_DRAWER_SELECTORS[i]);
      if (el) return { el: el, sel: TF_DRAWER_SELECTORS[i] };
    }
    return null;
  }

  /* Voorkom dat de cart-drawer opent (we tonen een toast i.p.v. de drawer). */
  function tfCloseDrawer() {
    var d = tfFindDrawer();
    if (d) {
      if (typeof d.el.close === 'function') { try { d.el.close(); } catch (e) {} }
      d.el.classList.remove('active', 'is-open', 'open', 'drawer--is-open');
    }
    document.documentElement.classList.remove('cart-drawer-open');
    document.body.classList.remove('cart-drawer-open', 'drawer-open', 'js-drawer-open');
  }

  /* Ververs de inhoud van de cart-drawer zónder hem te openen, zodat het
     product er meteen in staat als de klant op het winkelwagen-icoon klikt.
     We halen de huidige pagina op en vervangen het drawer-knooppunt. */
  function tfRefreshDrawer() {
    var found = tfFindDrawer();
    if (!found || !found.el.parentNode) return;
    fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(found.sel);
        var cur = tfFindDrawer();
        if (fresh && cur && cur.el.parentNode) {
          cur.el.parentNode.replaceChild(document.importNode(fresh, true), cur.el);
          tfCloseDrawer();
        }
      })
      .catch(function () {});
  }

  function init(root) {
    if (!root || root.__tfInit) return;
    root.__tfInit = true;

    var ctaAdd = root.getAttribute('data-cta-add') || 'In winkelwagen';
    var ctaAdded = root.getAttribute('data-cta-added') || 'Toegevoegd ✓';
    var openDrawer = root.getAttribute('data-open-drawer') === 'true';
    var live = root.querySelector('[data-tf-live]');

    root.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-tf-qty-minus]');
      var plus = e.target.closest('[data-tf-qty-plus]');
      var add = e.target.closest('[data-tf-add]');

      if (minus) { e.preventDefault(); stepQty(minus, -1); return; }
      if (plus)  { e.preventDefault(); stepQty(plus, 1);  return; }
      if (add)   { e.preventDefault(); addToCart(add);    return; }
    });

    function getCard(el) { return el.closest('[data-tf-card]'); }

    function qtyEls(card) {
      return {
        wrap: card.querySelector('[data-tf-qty]'),
        num: card.querySelector('[data-tf-qty-num]')
      };
    }

    function stepQty(btn, delta) {
      var card = getCard(btn);
      if (!card) return;
      var els = qtyEls(card);
      if (!els.num) return;
      var val = parseInt(els.num.textContent, 10) || 1;
      val = Math.max(1, val + delta);
      els.num.textContent = val;
    }

    function addToCart(btn) {
      var card = getCard(btn);
      if (!card) return;
      var variantId = btn.getAttribute('data-variant-id') || card.getAttribute('data-variant-id');
      if (!variantId) return;

      var els = qtyEls(card);
      // Stepper zichtbaar maken na eerste klik; daarna telt de stepper-waarde.
      var qty = 1;
      if (els.wrap && !els.wrap.hasAttribute('hidden')) {
        qty = parseInt(els.num.textContent, 10) || 1;
      }

      var original = btn.textContent;
      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (j) { throw j; });
          return res.json();
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.disabled = false;
          btn.textContent = ctaAdded;
          var title = card.getAttribute('data-product-title');
          if (live) live.textContent = (title || 'Product') + ' toegevoegd aan winkelwagen.';
          tfToast(title ? (title + ' toegevoegd') : 'Toegevoegd aan winkelwagen');

          // Toon de stepper zodat klant snel meer kan toevoegen.
          if (els.wrap && els.wrap.hasAttribute('hidden')) {
            els.wrap.removeAttribute('hidden');
          }

          refreshCart();

          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.textContent = ctaAdd || original;
          }, 1800);
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          btn.textContent = original;
          var msg = (err && err.description) ? err.description : 'Kon niet toevoegen.';
          if (live) live.textContent = msg;
          console.warn('[tf-collection] add to cart failed:', err);
        });
    }

    /* We tonen een toast i.p.v. de drawer. Daarom GEEN cart-update broadcast
       (die zorgde dat het thema de drawer leeg opende) — alleen de count-bubble
       bijwerken, de drawer sluiten en de inhoud verversen. */
    function refreshCart() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll(
            '.cart-count-bubble span:first-child, [data-cart-count], .cart-count, .site-header__cart-count'
          ).forEach(function (node) {
            node.textContent = cart.item_count;
          });
          tfCloseDrawer();
          // Drawer-inhoud verversen zodat het product er meteen in staat.
          tfRefreshDrawer();
        })
        .catch(function () {});
    }
  }

  function boot() {
    document.querySelectorAll('[data-tf-collection]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: opnieuw initialiseren bij section load
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-tf-collection]');
    if (sec) init(sec);
  });
})();
